import { render } from "./GPSModal.vue?vue&type=template&id=fbddb536&scoped=true"
import script from "./GPSModal.vue?vue&type=script&lang=js"
export * from "./GPSModal.vue?vue&type=script&lang=js"

import "./GPSModal.vue?vue&type=style&index=0&id=fbddb536&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbddb536"]])

export default __exports__